import { YesNoIndicators } from './api-model';
import { TcsmFeatures } from './features-model';

export interface AuthToken {
	roles: {
		DiocesanReports: {
			AccessArrearsReport: string[],
			AccessClergyLayCompReports: string[],
			AccessImputedIncomeReport: string[],
			Reports_SuperUser: string[],
		},
		ECD: {
			CPGSuperUser: string[],
			CPGSuperUserReadOnly: string[],
		},
		EmployeeRoster: {
			ER_SuperUser: string[],
			SeniorOfficer: string[],
			AdminOfficer: string[],
		},
		WAM: {
			WAM_CEDashboardUser: string[],
			WAM_UserAccessManager: [],
			WAM_SuperAdmin: string[],
		},
		MLPS: {
			MLPS_Viewer: string[],
			JuniorGroupPlanAdmin: string[],
			SeniorGroupPlanAdmin: string[],
		},
		InstitutionRoster: {
			DiocesanAdministrator: string[],
			DiocesanAssociateAdministrator: string[],
			IR_SuperUser: [],
		},
		BenAdmin: {
			SuperAdmin: string[],
			ROOAdmin: string[],
		},
		OrdinationOfficers: {
			OrdinationOfficer: string[],
		}
	},
	person: {
		cn: string,
		fn: string,
		ln: string,
		pe: string,
		oe: string,
		guid: string,
	},
}


export interface ForbiddenFeature {
	feature: TcsmFeatures;
	code: number;
}

export interface ApplicationList {
	app_id: string;
	app_name: string;
	landing_page: string;
}

export interface PersonBenefitFacts {
	tec_clergy: YesNoIndicators,
	tec_clergy_good_standing: YesNoIndicators,
	tec_clergy_is_deacon: YesNoIndicators,
	tec_clergy_is_deacon_vocational: YesNoIndicators,
	tec_clergy_is_priest: YesNoIndicators,
	tec_clergy_is_bishop: YesNoIndicators,
	employed_at_tec_org: YesNoIndicators,
	employed_at_tec_org_full_time: YesNoIndicators,
	employed_at_tec_org_part_time: YesNoIndicators,
	retired_db: YesNoIndicators,
	retired_dc: YesNoIndicators,
	retired: YesNoIndicators,
	enrolled_in_dc_plan: YesNoIndicators,
	segment_active_clergy_eligible_for_benefits: YesNoIndicators,
	segment_active_clergy_not_eligible_for_benefits: YesNoIndicators,
	segment_clergy_retired: YesNoIndicators,
	segment_active_lay_full_time: YesNoIndicators,
	segment_active_lay_part_time: YesNoIndicators,
	segment_active_enrolled_in_dc: YesNoIndicators,
	segment_active_lay_not_enrolled_in_dc: YesNoIndicators,
	segment_active_clergy_not_enrolled_in_dc: YesNoIndicators,
	segment_lay_retired: YesNoIndicators,
	segment_lay_beneficiary_or_survivor: YesNoIndicators,
	segment_lay_with_db_or_dc_benefits: YesNoIndicators,
	segment_clergy_with_db_or_dc_benefits: YesNoIndicators,
}

export const roleMapping = {
	DiocesanReports: 'diocesan_reports',
	ECD: 'ecd',
	EmployeeRoster: 'employee_roster',
	WAM: 'wam',
	MLPS: 'mlps',
	InstitutionRoster: 'institution_roster',
	BenAdmin: 'ben_admin',
	Customer360 : 'customer360',
};

export interface Role {
    role_name: string;
    role_target: string;
	implicit: boolean;
	institution_name?: string;
	opted_in?: boolean;
}

export interface RoleObject {
	ecd: Role[];
	employee_roster: Role[];
	institution_roster: Role[];
	mlps: Role[];
	mcaa: Role[];
	diocesan_reports: Role[];
	ben_admin: Role[];
	wam: Role[];
	customer360: Role[];
}


export interface AuthenticatedState {
	clientGuid: string;
	accessToken: string;
	forbiddenFeatures: ForbiddenFeature[];
	applicationList: ApplicationList[];
	roles?: string[];
	benefitFacts?: PersonBenefitFacts;
	roleObject?: RoleObject;
}

export enum AuthenticatedActionTypes {
	ADD_FORBIDDEN_FEATURE = 'ADD_FORBIDDEN_FEATURE',
	REMOVE_FORBIDDEN_FEATURE = 'REMOVE_FORBIDDEN_FEATURE',
	CLEAR_FORBIDDEN_FEATURES = 'CLEAR_FORBIDDEN_FEATURES',
	SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN',
	SET_CLIENT_GUID = 'SET_CLIENT_GUID',
	SET_APPLICATION_LIST = 'SET_APPLICATION_LIST',
	SET_ROLES = 'SET_ROLES',
	SET_BENEFIT_FACTS = 'SET_BENEFIT_FACTS',
	SET_ROLE_OBJECT = 'SET_ROLE_OBJECT',

}